"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodashDebounce = _interopRequireDefault(require("lodash.debounce"));
var _glide = _interopRequireDefault(require("@glidejs/glide"));
var _excluded = ["imageGalleryElement", "responsive"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var _default = function _default(_ref) {
  var imageGalleryElement = _ref.imageGalleryElement,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? [] : _ref$responsive,
    options = _objectWithoutProperties(_ref, _excluded);
  var slides = imageGalleryElement.querySelectorAll('.glide__slides > li');
  var glide = '';
  var transformCount = 0;
  var breakpointSettings = _objectSpread({
    500: {
      perView: 1,
      peek: {
        before: 0,
        after: 0
      }
    },
    954: {
      perView: 1, 
      peek: {
        before: 0,
        after: 0
      }
    },
    1025: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 834
    },
    1200: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 954
    },
    1600: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 1354
    },
    1900: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 1754
    }
  }, responsive);
  var getCurrentSettings = function getCurrentSettings() {
    var screenWidth = window.innerWidth;

    // Because the `perView` changes at different breakpoints, find
    // the relevant setting for the current screensize.
    // Filter out any settings that are smaller than the current size, and
    // then use the first in the list, as this will be the most relevant.
    // If none are available, assume we are using the biggest setting.

    // TODO: We should be able to reuse this, if we want to change the pagination
    // to scroll full pages, rather than individual items
    var breakpointSettingsForCurrentSize = Object.keys(breakpointSettings).filter(function (i) {
      return parseInt(i, 10) > screenWidth;
    })[0] || Object.keys(breakpointSettings).slice(-1);
    return breakpointSettings[breakpointSettingsForCurrentSize];
  };
  var updateBulletSize = function updateBulletSize(dot, action) {
    if (action === 'add') {
      imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(dot, "']")).classList.add('small');
    } else {
      imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(dot, "']")).classList.remove('small');
    }
  };
  var setBulletDefaultSize = function setBulletDefaultSize() {
    var maxDots = 5;
    var totalCount = slides.length;
    var navigationElements = imageGalleryElement.querySelectorAll(".glide-carousel__pagination > [data-slide-no]");
    if (totalCount > maxDots) {
      navigationElements.forEach(function (item) {
        item.classList.remove('small');
      });
      transformCount = 0;
      // eslint-disable-next-line no-param-reassign
      imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = 'translateX(0)';
      updateBulletSize(4, 'add');
    }
  };
  var setBulletSize = function setBulletSize(currentSlide, nextSlide) {
    var maxDots = 5;
    var transformXIntervalNext = -24;
    var transformXIntervalPrev = 24;
    var totalCount = slides.length;
    if (totalCount > maxDots) {
      if (nextSlide > currentSlide) {
        if (imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(nextSlide, "']")).classList.contains('small')) {
          if (!imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no]:last-child").classList.contains('small')) {
            // eslint-disable-next-line operator-assignment
            transformCount = transformCount + transformXIntervalNext;
            updateBulletSize(nextSlide, 'remove');
            var nextSlidePlusOne = nextSlide + 1;
            updateBulletSize(nextSlidePlusOne, 'add');
            // eslint-disable-next-line no-param-reassign
            imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = "translateX(".concat(transformCount, "px)");
            var pPointer = nextSlide - 3;
            var pPointerMinusOne = pPointer - 1;
            updateBulletSize(pPointerMinusOne, 'remove');
            updateBulletSize(pPointer, 'add');
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (nextSlide === slides.length - 1) {
            var navigationElements = imageGalleryElement.querySelectorAll(".glide-carousel__pagination > [data-slide-no]");
            navigationElements.forEach(function (item) {
              item.classList.remove('small');
            });
            updateBulletSize(slides.length - 5, 'add');
            transformCount = (slides.length - 5) * transformXIntervalNext;
            // eslint-disable-next-line no-param-reassign
            imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = "translateX(".concat(transformCount, "px)");
          }
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(nextSlide, "']")).classList.contains('small')) {
          if (!imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no]:first-child").classList.contains('small')) {
            // eslint-disable-next-line operator-assignment
            transformCount = transformCount + transformXIntervalPrev;
            updateBulletSize(nextSlide, 'remove');
            var _nextSlidePlusOne = nextSlide - 1;
            updateBulletSize(_nextSlidePlusOne, 'add');
            // eslint-disable-next-line no-param-reassign
            imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = "translateX(".concat(transformCount, "px)");
            var nPointer = currentSlide + 3;
            var nPointerMinusOne = nPointer - 1;

            // console.log(`${nPointer} - ${nPointerMinusOne}`);
            updateBulletSize(nPointer, 'remove');
            updateBulletSize(nPointerMinusOne, 'add');
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (nextSlide === 0) {
            setBulletDefaultSize();
          }
        }
      }
    }
  };
  var countLeftPad = function countLeftPad(number) {
    var slideCount = number.toString();

    // eslint-disable-next-line no-undef
    return slideCount.padStart(2, '0');
  };
  var setSlideCount = function setSlideCount(currentIndex) {
    var slideCountBlock = imageGalleryElement.querySelector('.image-gallery__totalslides--count');
    slideCountBlock.innerHTML =" ".concat("Image ").concat(countLeftPad(currentIndex + 1), "/").concat(countLeftPad(slides.length));
    // slideCountBlock.innerHTML ="<img src=\'../../assets/svg/image-icon.svg\' width=\'16px\' height=\'16px\'>".concat(" ", "Image ").concat(countLeftPad(currentIndex + 1), "/").concat(countLeftPad(slides.length));
  };
  var showPaginationByPage = function showPaginationByPage() {
    // Glide shows a pagination button for each item, and doesn't provide
    // an option to navigate whole pages at a time.
    // This function hides extra individual dots, so that only the first item of
    // each page is shown. (Based on the `perView` setting).
    var _getCurrentSettings = getCurrentSettings(),
      perView = _getCurrentSettings.perView;
    var paginationElements = imageGalleryElement.querySelectorAll(".glide-carousel__pagination button:not(:nth-child(".concat(perView, "n + 1))"));
    paginationElements.forEach(function (item) {
      item.classList.add('hidden');
    });
    setSlideCount(0);
    setBulletDefaultSize();
  };
  var showHideNavigation = function showHideNavigation() {
    var maxPerView = getCurrentSettings().perView;
    var navigationElements = imageGalleryElement.querySelectorAll('[data-slide-no]');
    if (!slides || slides.length <= maxPerView) {
      navigationElements.forEach(function (item) {
        return item.classList.add('hidden');
      });
      // eslint-disable-next-line no-param-reassign
      imageGalleryElement.querySelector('.image-gallery__navigation').style.display = 'none';
      // eslint-disable-next-line no-param-reassign
      imageGalleryElement.querySelector('.image-gallery__totalslides').style.display = 'none';
      imageGalleryElement.querySelector('.glide__slides').classList.add('singleslide');
      return;
    }
    navigationElements.forEach(function (item) {
      return item.classList.remove('hidden');
    });
    showPaginationByPage();
  };
  var createPagination = function createPagination() {
    var bulletContainer = document.createElement('div');
    bulletContainer.classList.add('glide-carousel__pagination');
    bulletContainer.dataset.glideEl = 'controls[nav]';
    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.dataset.slideNo = "".concat(index);
      button.tabIndex = '-1';
      bulletContainer.appendChild(button);
    });
    imageGalleryElement.querySelector('.carousel-nav-wrapper').appendChild(bulletContainer);
    showHideNavigation();
  };
  var setPeekVal = function setPeekVal() {
    var peekVal = 0;
    if (document.body.clientWidth > 1025 && document.body.clientWidth < 1200) {
      peekVal = (document.body.clientWidth - 834) / 2;
    }
    else if(document.body.clientWidth > 1200 && document.body.clientWidth < 1280) {
      peekVal = (document.body.clientWidth - 954) / 2;
    }
    else if (document.body.clientWidth > 1281) {
      peekVal = 154;
    }
    glide.update({
      peek: {
        before: peekVal,
        after: peekVal
      }
    });
  };
  createPagination();
  window.addEventListener('resize', (0, _lodashDebounce["default"])(function () {
    // Hide the navigation when we don't have more items than we can show on screen
    showHideNavigation();
    setPeekVal();
  }, 250));
  glide = new _glide["default"](imageGalleryElement, _objectSpread({
    perView: 1,
    type: 'carousel',
    breakpoints: breakpointSettings,
    // Remove draggable property for desktop
    dragThreshold: false,
    // Remove swipe property for smaller devices
    // swipeThreshold: false,
    peek: {
      before: 100,
      after: 100
    }
  }, options)).mount();
  glide.on('run', function () {
    var currentSlide = imageGalleryElement.querySelector('.glide-carousel__pagination > [data-slide-no].glide__bullet--active').getAttribute('data-slide-no');
    var nextSlide = glide.index;

    // console.log(`${currentSlide} - ${nextSlide}`);
    // eslint-disable-next-line radix
    setBulletSize(parseInt(currentSlide), nextSlide);
    setSlideCount(nextSlide);
    updateBulletSize(nextSlide, 'remove');
  });
  if (slides.length === 1) {
    glide.update({
      type: 'slider',
      peek: {
        before: 0,
        after: 0
      }
    });
  } else {
    setPeekVal();
  }
  return glide;
};
exports["default"] = _default;


// WEBPACK FOOTER //
// ./components/cwm-gallery-carousel/scripts/cwm-carousel-image-gallery.js